const benefitEstimatorV2Module = {
  state: {
    benefit_estimator_scenarios: [],
    benefit_estimator_services: [],
    benefit_estimator_default_options: [],
    benefit_estimator_scenario: null,
    benefit_estimator_quote: null,
    benefit_estimator_quote_id: null,
    benefit_estimator_compare_reference: null,
    benefit_estimator_quote_payload: {
      filled: false,
      category_id: null,
      traveler_details: [
        {
          age: null,
          dob: null,
          citizenship: null,
          residency: null,
        },
      ],
      destination: [],
      coverage_start_date: null,
      coverage_end_date: null,
      scenario_id: null,
    },
    benefit_estimator_premiums_batch_response: null,
    default_messages: {
      plan_card: {
        plan_card_copay_text: null,
        plan_card_buy_tooltip: null,
      },
    },
    benefit_estimator_recompute_plan_list_signal: {
      last_signal: -1,
      options: {
        invoke_recompute_premiums: false,
        invoke_recompute_premiums_delay: 500,
      },
    },
  },
  getters: {
    benefit_estimator_scenarios: (state) => state.benefit_estimator_scenarios,
    benefit_estimator_services: (state) => state.benefit_estimator_services,
    benefit_estimator_default_options: (state) =>
      state.benefit_estimator_default_options,
    benefit_estimator_scenario: (state) => state.benefit_estimator_scenario,
    benefit_estimator_quote: (state) => state.benefit_estimator_quote,
    benefit_estimator_quote_id: (state) => state.benefit_estimator_quote_id,
    benefit_estimator_quote_payload: (state) =>
      state.benefit_estimator_quote_payload,
    default_messages_plan_card: (state) => state.default_messages.plan_card,
    get_benefit_estimator_recompute_plan_list_signal: (state) =>
      state.benefit_estimator_recompute_plan_list_signal,
    benefit_estimator_compare_reference: (state) =>
      state.benefit_estimator_compare_reference,
  },
  mutations: {
    benefit_estimator_scenarios_set(state, payload) {
      state.benefit_estimator_scenarios = payload;
    },
    benefit_estimator_services_set(state, payload) {
      state.benefit_estimator_services = payload;
    },
    benefit_estimator_default_options_set(state, payload) {
      state.benefit_estimator_default_options = payload;
    },
    benefit_estimator_scenario_set(state, payload) {
      state.benefit_estimator_scenario = payload;
    },
    benefit_estimator_quote_set(state, payload) {
      state.benefit_estimator_quote = payload.quote;
      state.benefit_estimator_quote_id = payload.quoteId;
    },
    benefit_estimator_quote_payload_set(state, payload) {
      state.benefit_estimator_quote_payload = payload;
    },
    benefit_estimator_premiums_batch_response(state, payload) {
      state.benefit_estimator_premiums_batch_response = payload;
    },
    benefit_estimator_default_plan_card_messages(state, payload) {
      state.default_messages.plan_card = payload;
    },
    benefit_estimator_compare_reference_set(state, payload) {
      state.benefit_estimator_compare_reference = payload;
    },
    set_benefit_estimator_recompute_plan_list_signal(state, options = {}) {
      let signal = state.benefit_estimator_recompute_plan_list_signal;

      signal.last_signal = Date.now();
      signal.options.invoke_recompute_premiums =
        options?.invoke_recompute_premiums ?? true;
      signal.options.invoke_recompute_premiums_delay =
        options?.invoke_recompute_premiums_delay ?? 500;
    },
  },
  actions: {
    fetch_benefit_estimator_scenarios({ commit }) {
      return new Promise((resolve, reject) => {
        let url = "/benefitestimator/scenarioslist/";
        this.$http
          .get(url)
          .then((res) => {
            if (res.data.scenarios) {
              commit("benefit_estimator_scenarios_set", res.data.scenarios);
              resolve(res.data.scenarios);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_benefit_estimator_services({ commit }) {
      return new Promise((resolve, reject) => {
        let url = "/benefitestimator/serviceslist/";
        this.$http
          .get(url)
          .then((res) => {
            if (res.data.services) {
              commit("benefit_estimator_services_set", res.data.services);
              resolve(res.data.services);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_benefit_estimator_default_options({ commit }) {
      return new Promise((resolve, reject) => {
        let url = "/benefitestimator/defaultoptionlist/";
        this.$http
          .get(url)
          .then((res) => {
            if (res.data.benefit_estimator_default_options) {
              commit(
                "benefit_estimator_default_options_set",
                res.data.benefit_estimator_default_options
              );

              resolve(res.data.benefit_estimator_default_options);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_benefit_estimator_scenario({ commit }, id) {
      commit("benefit_estimator_scenario_set", null);
      commit("benefit_estimator_quote_set", { quote: null, quoteId: null });

      return new Promise((resolve, reject) => {
        let url = `/benefitestimator/scenarioservicelist/${id}/`;
        this.$http
          .get(url)
          .then((res) => {
            if (res.data.scenario && res.data.service_list) {
              commit("benefit_estimator_scenario_set", res.data);
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_benefit_estimator_quote({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("benefit_estimator_quote_set", { quote: null, quoteId: null });
        let url = `/benefitestimator/scenarioquote/visitor/`;
        this.$http
          .post(url, payload)
          .then((res) => {
            if (res.data.quote && res.data.quoteId) {
              commit("benefit_estimator_quote_set", res.data);
              commit("benefit_estimator_scenario_set", res.data.scenarioData);
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_benefit_estimator_requirements({ commit }) {
      return new Promise((resolve, reject) => {
        let url = `/benefitestimator/get_requirements/`;
        this.$http
          .get(url)
          .then((res) => {
            if (
              res.data.services &&
              res.data.scenarios &&
              res.data.benefit_estimator_default_options
            ) {
              commit("benefit_estimator_services_set", res.data.services);
              commit("benefit_estimator_scenarios_set", res.data.scenarios);
              commit(
                "benefit_estimator_default_options_set",
                res.data.benefit_estimator_default_options
              );
              let planCardOpts = {
                plan_card_buy_tooltip:
                  res.data.benefit_estimator_default_options?.find(
                    (opt) => opt.option_slug == "plan_card_buy_tooltip"
                  )?.option_value,
                plan_card_copay_text:
                  res.data.benefit_estimator_default_options?.find(
                    (opt) => opt.option_slug == "plan_card_copay_text"
                  )?.option_value,
              };
              commit(
                "benefit_estimator_default_plan_card_messages",
                planCardOpts
              );
              resolve(res.data);
            } else {
              reject("Invalid Response");
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    set_benefit_estimator_quote_payload({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit("benefit_estimator_quote_payload_set", payload);
          resolve(payload);
        } catch (error) {
          reject(error);
        }
      });
    },
    get_premiums_by_batch({ commit }, payload, type = "visitor") {
      return new Promise((resolve, reject) => {
        this.$http
          .post("/benefitestimator/get_premiums_batch/" + type + "/", payload)
          .then((res) => {
            commit(
              "benefit_estimator_premiums_batch_response",
              res.data.result
            );
            resolve(res.data.result);
          })
          .catch((err) => reject(err));
      });
    },
    compare_plans({ commit }, payload, type = "visitor") {
      return new Promise((resolve, reject) => {
        this.$http
          .post("/benefitestimator/compareplans/" + type + "/", payload)
          .then((res) => {
            commit(
              "benefit_estimator_compare_reference_set",
              res.data.reference_code
            );
            resolve(res.data);
          })
          .catch((err) => reject(err));
      });
    },
  },
};

export { benefitEstimatorV2Module };
